import intermind from '../../../index';
import { ParticipantRequestStatus } from '../types/participant.types';

export class JoinRequestResource {
  async approve(id: string): Promise<void> {
    await intermind.httpClient.patch(`/participants/join-requests/${id}/status`, {
      status: ParticipantRequestStatus.APPROVED,
    });
  }

  async reject(id: string): Promise<void> {
    await intermind.httpClient.patch(`/participants/join-requests/${id}/status`, {
      status: ParticipantRequestStatus.REJECTED,
    });
  }
}
